import { jsxs, jsx } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { useFocusRing } from "@react-aria/focus";
import { Checkmark } from "./Checkmark.js";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
const pointerEventsClassname = "ds-checkbox__pointer-events-wrapper";
function Checkbox({
  isChecked = false,
  isDisabled = false,
  isIndeterminate = false,
  inputProps,
  subtext,
  children,
  onChange = () => {
  },
  // eslint-disable-line @typescript-eslint/no-empty-function
  id,
  ...props
}) {
  const {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  return /* @__PURE__ */ jsxs(Container, {
    $isIndeterminate: isIndeterminate,
    $isDisabled: isDisabled,
    $isChecked: isChecked,
    className: pointerEventsClassname,
    ...props,
    children: [/* @__PURE__ */ jsx(Input, {
      type: "checkbox",
      ref: (element) => {
        if (element) {
          element.indeterminate = isIndeterminate;
        }
      },
      "aria-checked": isIndeterminate ? "mixed" : isChecked,
      disabled: isDisabled,
      checked: isChecked,
      onChange,
      id,
      ...focusProps,
      ...inputProps
    }), /* @__PURE__ */ jsx(IndicatorPosition, {
      children: /* @__PURE__ */ jsxs(Indicator, {
        $isFocusVisible: isFocusVisible,
        $isIndeterminate: isIndeterminate,
        $isDisabled: isDisabled,
        $isChecked: isChecked,
        children: [isChecked && /* @__PURE__ */ jsx(Checkmark, {}), isIndeterminate && /* @__PURE__ */ jsx(IndeterminateMark, {})]
      })
    }), children && /* @__PURE__ */ jsxs(Label, {
      $isDisabled: isDisabled,
      children: [children, subtext && /* @__PURE__ */ jsx(SubtextHolder, {
        $isDisabled: isDisabled,
        children: subtext
      })]
    })]
  });
}
Checkbox.pointerEventsClassname = pointerEventsClassname;
const Container = styled.label.withConfig({
  displayName: "Container",
  componentId: "sc-1xpfd3x-0"
})(["", " display:flex;align-items:flex-start;margin:0;padding:", " 0;cursor:", ";user-select:none;"], textStyles.uiTextM, token.spacing1, (props) => !props.$isDisabled && "pointer");
const IndicatorPosition = styled.div.withConfig({
  displayName: "IndicatorPosition",
  componentId: "sc-1xpfd3x-1"
})(["display:flex;flex:none;align-items:center;&::before{content:'​';}"]);
const Indicator = styled.div.withConfig({
  displayName: "Indicator",
  componentId: "sc-1xpfd3x-2"
})(["position:relative;display:flex;justify-content:center;align-items:center;box-sizing:border-box;width:16px;height:16px;border:2px solid ", ";border-radius:", ";background-color:transparent;&::before{content:'';position:absolute;top:-5px;right:-5px;bottom:-5px;left:-5px;border:", " solid transparent;border-radius:calc( ", " + 3px );}", " ", " ", " ", " ", ":hover &&,", ":focus-visible &&{", " background-color:", ";}"], token.componentCheckboxBorderUnchecked, token.radiusMedium, token.focusRingWidth, token.radiusMedium, (props) => props.$isFocusVisible && css(["border-color:", ";&::before{border-color:", ";}"], token.componentCheckboxBorderUncheckedFocus, props.$isChecked || props.$isIndeterminate ? token.focusRingColorPrimary : token.focusRingColorSecondary), (props) => props.$isChecked && css(["border-color:transparent;background-color:", ";fill:#fff;"], token.blue500), (props) => props.$isIndeterminate && css(["border-color:transparent;background-color:", ";"], token.blue500), (props) => props.$isDisabled && css(["border-color:transparent;background-color:", ";fill:", ";"], token.componentCheckboxFillDisabled, token.componentCheckboxCheckmarkColorDisabled), "." + pointerEventsClassname, "." + pointerEventsClassname, (props) => !props.$isChecked && !props.$isIndeterminate && !props.$isDisabled && `border-color: ${token.componentCheckboxBorderUncheckedHover};`, (props) => (props.$isChecked || props.$isIndeterminate) && !props.$isDisabled ? token.blue600 : void 0);
const Input = styled.input.withConfig({
  displayName: "Input",
  componentId: "sc-1xpfd3x-3"
})(["position:absolute;overflow:hidden;clip:rect(0,0,0,0);width:1px;height:1px;margin:0 -1px -1px 0;padding:0;border:0;white-space:nowrap;clip-path:inset(50%);"]);
const IndeterminateMark = styled.div.withConfig({
  displayName: "IndeterminateMark",
  componentId: "sc-1xpfd3x-4"
})(["width:8px;height:2px;border-radius:", ";background-color:", ";"], token.radiusPill, token.white);
const Label = styled.div.withConfig({
  displayName: "Label",
  componentId: "sc-1xpfd3x-5"
})(["display:block;margin-left:8px;color:", ";"], (props) => props.$isDisabled ? token.colorTextDisabled : token.colorText);
const SubtextHolder = styled.span.withConfig({
  displayName: "SubtextHolder",
  componentId: "sc-1xpfd3x-6"
})(["display:block;color:", ";font-size:", ";"], (props) => props.$isDisabled ? token.colorTextDisabled : token.colorTextMuted, token.fontSize75);
export {
  Checkbox
};
//# sourceMappingURL=Checkbox.js.map
